// extracted by mini-css-extract-plugin
module.exports = {"googleAdHolder":"styles_googleAdHolder__3Vuiq","googleAd":"styles_googleAd__20Wk0"};